import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'

import moment from 'moment';
import setting from "../../config/setting";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

let id = 0;
function createData(PO_ID, flags, CreatedBy, Created_Date, Vendor_Name) {
    id += 1;
    return { id, PO_ID, flags, CreatedBy, Created_Date, Vendor_Name};
}

//const rows = [
//    createData('OE11000660', [{
//        name: "Missing Documents",
//        avatar: "MD",
//        color: "mid"
//    }, {
//        name: "Duplicate Entry",
//        avatar: "DE",
//        color: "mid",
//        avatarD: "1"
//    }, {
//        name: "Missing Amount",
//        avatar: "MA",
//        color: "high"
//    }
//    ], "JiaJie", "14-SEP-18", "E SERVICES SINGAPORE PTE. LED."),
//    createData('OE11000661', [{
//        name: "Missing Documents",
//        avatar: "MD",
//        color: "mid"
//    }, {
//        name: "Duplicate Entry",
//        avatar: "DE",
//        color: "mid"
//    }], "JiaJie", "14-SEP-18", "E SERVICES SINGAPORE PTE. LED."),
//    createData('OE11000662', [{
//        name: "Missing Documents",
//        avatar: "MD",
//        color: "mid"
//    }, {
//        name: "Duplicate Entry",
//        avatar: "DE",
//        color: "mid"
//    }], "JiaJie", "14-SEP-18", "E SERVICES SINGAPORE PTE. LED."),
//    createData('OE11000663', [{
//        name: "Missing Documents",
//        avatar: "MD",
//        color: "mid"
//    }, {
//        name: "Missing Amount",
//        avatar: "MA",
//        color: "high"
//    }], "JiaJie", "14-SEP-18", "E SERVICES SINGAPORE PTE. LED."),
//    
//];

class DuplicateTxnTable extends Component {

    render() {
        console.log("duplicate transctions data!")
        console.log(this.props.data);
        const classes = this.props;
        // console.log("Txn props:");
        // console.log(this.props);
        let i = 0;
        let k = 0;

        let titleString = this.props.data == null ? null : (this.props.data)[0].risk_name
        let subTitleString = this.props.data == null ? null : (this.props.data)[0].kri_id + ': ' + (this.props.data)[0].description
        let headermapping = {
            Period: 'period',
            Status: 'report_status',
            Owner: 'owner'
        }
        return (
            <div className={classes.root}>

                <Typography> {titleString}</Typography>
                <Typography> {subTitleString}</Typography>
                <Table className={classes.table} padding='dense'>
                    <TableHead>
                        <TableRow>
                            {this.props.header.map(header =>{
                                k++
                                return(
                                    <TableCell key = {k}>{header.replace(/_/g, ' ')}</TableCell>
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.data == null ? null : this.props.data
                            .sort((a, b)=>a.period > b.period?-1:1)
                            .slice(0, 10)
                            .map(n => {
                                return (
                                    <TableRow key={n.id} hover onClick={()=>{this.props.clickHandler(n)}}>
                                        {this.props.header.map(header =>{
                                            if (header == 'Status') {
                                                return (
                                                    <TableCell style={{color: n[headermapping[header]] == 'Open' ? setting.COLOR.RED : setting.COLOR.GREEN}}>
                                                        {n[headermapping[header]]}
                                                    </TableCell>
                                                )
                                            }
                                            if (header === 'Period') {
                                                return (<TableCell style={{whiteSpace:'nowrap'}}>{moment(n[headermapping[header]]).format('YYYY-MMM')}</TableCell>)
                                            }
                                            return (
                                                <TableCell>{n[headermapping[header]]}</TableCell>
                                            )}
                                        )}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </div>
        )
    }
}
export default withStyles(styles)(DuplicateTxnTable)


// WEBPACK FOOTER //
// ./src/components/KRI/KRIReportingDetailTable.js